module.exports = __webpack_public_path__ + "static/media/150-bolivia.09ded748.svg";